module.exports = __webpack_public_path__ + "a4fe042e2487e9f63f8cd644cf3bc63e.png";